import ScrollToTop from "../../components/ScrollToTop.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import WorthToKnowSectionComponent from "../../components/alternative-frontpages/WorthToKnowSectionComponent.tsx";
import WhatYouAreGettingSectionComponent from "../../components/alternative-frontpages/WhatYouAreGettingSectionComponent.tsx";
import WhyChooseHiperSectionComponent from "../../components/alternative-frontpages/WhyChooseHiperSectionComponent.tsx";
import CallMeRTOComponent from "../../components/callMe/CallMeRTOComponent.tsx";
import IdaHeroComponent from "../../components/hero/IdaHeroComponent.tsx";
import setNoIndexMeta from "../../components/setNoIndexMeta.tsx";
import {CallMePhoneNumbers} from "../../util/contact.ts";


export default function IdaPage() {
    ScrollToTop()
    useDatalayer()
    setNoIndexMeta()
    setTitleAndMetaDescription(
        'Få 99 kr fibernet de første 6. mdr.',
        'Afhængigt af din adresse kan du få lynhurtigt fibernet for 99 kr de første 6 mdr. Hop ind på Hiper for at se, om du kan få den knivskarpe pris.'
    )

    /* utm_source=ida */

    return (
        <div className={"page-campaign-ida"}>
            <IdaHeroComponent/>
            <CallMeRTOComponent phoneNumberSet={CallMePhoneNumbers.Default} className={"rto--box page-home"}/>
            <WhatYouAreGettingSectionComponent/>
            <WorthToKnowSectionComponent/>
            <WhyChooseHiperSectionComponent/>
        </div>
    )
}
